import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';

import { LogbookEntry, IValueViewModel, ComponentDefinition, Group } from '../../models/index';
import { severityLevels } from '../../common/constants';
import { ICurrentApplicationService, IIdentifierVmService } from '../../services';
import { toDuration } from '../../services/helpers/toDuration';
import { EditableLogbookEntry } from '../../states/logbookState/EditableLogbookEntry';

class LogbookEntriesTableController implements angular.IComponentController {
    allVms: { [guid: string]: IValueViewModel } = {};
    editedEntries: LogbookEntry[];
    formController: angular.IFormController;
    levels: string[];
    selectedGroup: Group;
    
    readonly canEdit: (entry: EditableLogbookEntry) => boolean;
    readonly categories: string[];
    readonly entries: EditableLogbookEntry[];
    readonly format: string;
    readonly isEditMode: boolean;
    readonly onDelete: (entry: EditableLogbookEntry) => void;
    readonly userName: string;

    static $inject = ['identifierVmService', 'currentApplicationService'];
    constructor(
        private _identifierVmService: IIdentifierVmService,
        private _currentApplicationService: ICurrentApplicationService
    ) {
    }

    $onInit() {
        //this.selectedGroups = {};
        this.levels = severityLevels.map(d => d.value);
        this.onEntryChanged = this.onEntryChanged.bind(this);
        this._identifierVmService.getAllViewModels().then(vms => vms.forEach(vm => this.allVms[vm.guid] = vm));
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj['entries']) {
            this.editedEntries = [];
        }
    }

    onGroupChange(item, entry: LogbookEntry) {
        this.onApplyRange()(entry);
        entry.identifier = null;
    }

    onApplyRange() {
        this.formController.$setDirty();
        return this.onEntryChanged;
    }

    onEntryChanged(entry: LogbookEntry) {
        const config = this._currentApplicationService.getApplicationConfiguration();
        // #36875 don't allow start and end date to be the same
        entry.range.startDate = moment(entry.range.startDate);
        entry.range.endDate = moment(entry.range.endDate);
        if (entry.range.startDate.isSame(entry.range.endDate)) {
            entry.range = {
                startDate: entry.range.startDate,
                endDate: entry.range.endDate.add(toDuration(config))
            };
        }
        if (this.editedEntries.indexOf(entry) < 0) {
            this.editedEntries.push(entry);
        }
    }
}

export const wtLogbookEntriesTable: ComponentDefinition = {
    componentId: 'wtLogbookEntriesTable',
    controller: LogbookEntriesTableController,
    controllerAs: 'vm',
    template: require('./logbookEntriesTable.component.html'),
    bindings: {
        canEdit: '&?',
        categories: '<',
        editedEntries: '=',
        entries: '<',
        format: '<',
        formController: '=?',
        isEditMode: '<?',
        onDelete: '&?',
        onSave: '&?',
        userName: '<?',
    }
};